import { FC, useState } from 'react'

import { removeEmptyKeys } from 'utils'
import { Modal } from '~shared'
import { Button } from '~ui'
import { useQueryParams } from '~hooks'
import SearchInput from '../search-input'
import Filters from '../filters'
import { FiltersProps } from '../index'

import styles from './MobileSide.module.scss'

interface MobileSideProps {
  title: string
}

const MobileSide: FC<MobileSideProps & FiltersProps & { placeholder: string }> = ({
  placeholder,
  title,
  items,
  isOpen: isFiltersOpen,
}) => {
  const { query } = useQueryParams()

  const [isOpen, setIsOpen] = useState(false)

  const selectedCount = Object.entries(removeEmptyKeys(query))
    .filter(([key]) => !['query'].includes(key as string))
    .map(([, values]) => values)
    .flat(1).length

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <>
      <Modal
        modalClassName={styles['modal-content-reset']}
        wrapperClassName={styles['modal-wrapper-reset']}
        isOpen={isOpen}
        onClose={toggleOpen}
        closeButton={false}
      >
        <div className={styles['modal-wrapper']}>
          <div className={styles.body}>
            <Filters items={items} isOpen={isFiltersOpen} />
          </div>
        </div>
        <div className={styles.bottom}>
          <Button variant="primary" onClick={toggleOpen} style={{ width: '100%' }}>
            Show results
          </Button>
        </div>
      </Modal>
      <div className={styles.wrapper}>
        <SearchInput placeholder={placeholder} />
        {items && items.length ? (
          <Button variant="secondary" onClick={toggleOpen}>
            {!!selectedCount && <span className={styles.count}>{selectedCount}</span>}
            <span className={styles.title}>{title}</span>
          </Button>
        ) : null}
      </div>
    </>
  )
}

export default MobileSide
